import { observer } from 'mobx-react'
import React, { Component } from 'react'
import Card from '../../components/Card'
import Grid from '../../components/Grid'
import Toggle from '../../components/Toggle'
import patient from '../../stores/patient'

const toggles = [
  'GOOD_PARENT',
  'GOOD_FRIEND',
  'GOOD_FAMILY_MEMBER',
  'GOOD_SPOUSE',
  'GOOD_COMMUNITY_MEMBER',
  'ATHLETIC',
  'HEALTHY',
  'SPIRITUAL',
  'RELIGIOUSLY_OBSERVANT',
  'COMPETENT',
  'SUCCESSFUL',
  'INDEPENDENT',
  'NON_HYPOCRITICAL',
  'RESPONSIBLE',
  'IN_CONTROL',
  'DISCIPLINED',
  'ON_TOP_OF_THINGS',
]

@observer
export default class MotivationToggles extends Component {
  render() {
    return (
      <Card>
        <Card.Pad>
          <Grid>
            {toggles.map((v, i) => (
              <Grid.HalfCell key={i}>
                <Toggle
                  color="red"
                  checked={patient.fields.motivations.includes(v)}
                  value={v}
                  str={`choices.motivation.${v}`}
                  onToggle={patient.toggleMotivation}
                />
              </Grid.HalfCell>
            ))}
          </Grid>
        </Card.Pad>
      </Card>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Goal/MotivationToggles.js